import React, { KeyboardEvent } from 'react';
import ApiAuth from '../code/api/ApiAuth';
import LoginModel from '../code/models/LoginModel';
import '../css/mainlogin.css';
import Api_Config from '../code/api/ApiConfig';
import { ApiConfigCompany } from '../code/models/ApiConfigCompany';
import { Spinner } from "reactstrap";

export default function MainLogin({ onLogin }) {
    const userNameRef = React.useRef<HTMLInputElement>();
    const pwdNameRef = React.useRef<HTMLInputElement>();
    const [currentCompany, setCurrentCompany] = React.useState<ApiConfigCompany>();
    const [loggingOn, setLoggingOn] = React.useState<boolean>(false);

    React.useEffect(() => {
        setCurrentCompany(Api_Config.getSelectedCompany());
    }, []);

    function handleLoginClick() {
        if (userNameRef.current && pwdNameRef.current) {
            const creds: LoginModel = {
                "logonId": userNameRef.current.value,
                "password": pwdNameRef.current.value
            };
            setLoggingOn(true);
            ApiAuth.login(creds).then(result => {
                if (result) {
                    onLogin();
                }
            }).finally(() => {
                setLoggingOn(false);
            });
        }
    }

    function companySelected(company: ApiConfigCompany) {
        Api_Config.setSelectedCompany(company);
        setCurrentCompany(company);
    }

    function buildDropDownItems(companies: ApiConfigCompany[]) {

        return companies.map((company) => {
            let btnPrefix = "vbtncomp-";
            let btnId = btnPrefix + company.companyId.replace(" ", "_");
            return (
                <React.Fragment key={"acrf-" + company.companyId}>
                    <input type="radio" className="btn-check"
                        name={btnPrefix}
                        id={btnId}
                        autoComplete="off" checked={company.companyId === currentCompany?.companyId}
                        onChange={(e) => { }}
                        onClick={() => companySelected(company)} />
                    <label className="btn btn-outline-primary"
                        htmlFor={btnId}>{company.displayName}</label>                    
                </React.Fragment>
            )
        });
    }

    function buildCompanyDropdown() {
        if (!currentCompany) return;
        let companies: ApiConfigCompany[] = Api_Config.getAvailableCompanies();

        return (
            <div key={"acbg-" + currentCompany?.companyId} className="btn-group" role="group" aria-label="radio toggle button group">
                {buildDropDownItems(companies)}
            </div>
        )
    }

    function handleKeyDown(event: KeyboardEvent<HTMLInputElement>): void {
        if (event.key === 'Enter') {
            event.preventDefault(); // Prevents default form submission if needed
            handleLoginClick();
        }
    }

    return (
        <main className='main-content'>
            <div className="container">
                <div className="row pad-top-20 justify-content-center">
                    <div className="col-md-6">
                        <div className="row pad-top-20 flex-nowrap">
                            {buildCompanyDropdown()}
                        </div>
                    </div>
                </div>
                <div className="row pad-top-20">
                    <div className="col"></div>
                    <div className="col-md-2">
                        <div className="row login-input">
                            <label htmlFor="loginUserName" className="form-label pad-top-20">User Name</label>
                            <input type="text" className="form-control" id="loginUserName" ref={userNameRef as React.RefObject<HTMLInputElement>}
                                autoCapitalize="off" autoCorrect="off" autoComplete="username" onKeyDown={handleKeyDown} />
                        </div>
                        <div className="row login-input">
                            <label htmlFor="loginPwd" className="form-label pad-top-20">Password</label>
                            <input type="password" className="form-control" id="loginPwd" ref={pwdNameRef as React.RefObject<HTMLInputElement>}
                                autoComplete="current-password" onKeyDown={handleKeyDown} />
                        </div>
                        <div className="row">
                            {!loggingOn && <button className="btn btn-primary login-button" onClick={handleLoginClick}>Sign In</button>}
                            {loggingOn && <Spinner color="primary" className="login-button-spinner" />}
                        </div>
                    </div>
                    <div className="col"></div>
                </div>
                <div className="row"></div>
            </div>
        </main>
    )
}
